import * as React from 'react';
import JackpotBox from '../JackpotBox/JackpotBox';

import { selectJackpots, decideJackpotBoxScale } from './utils';

import styles from './JackpotsContainer.module.scss';
import { JackpotStaticTexts } from '../../types';

import { WrapperSize, WrapperJackpotTiers, WrapperType } from '../../types';
import { JackpotBoxItem } from '../JackpotBox/JackpotBoxItem';
import { JackpotNumber, JackpotNumberDynamic } from '../JackpotNumber';

interface JackpotsContainerPropsInterface {
  wrapperSize: WrapperSize;
  currencyCode: string;
  locale: string;
  tiers: WrapperJackpotTiers;
  wrapperType: WrapperType;
  staticTexts: JackpotStaticTexts;
  timestamp: number;
}

const JackpotsContainer = ({
  wrapperSize,
  currencyCode,
  locale,
  tiers,
  wrapperType,
  staticTexts,
  timestamp,
}: JackpotsContainerPropsInterface) => {
  const selectedJackpots = selectJackpots(tiers, wrapperSize);
  const wonTier = tiers.find(tier => tier.state === 'won');

  if (wonTier) {
    return (
      <div data-testid="jackpot-overlay">
        <JackpotBox
          state={'won'}
          scale={decideJackpotBoxScale(1, wrapperSize)}
          timeStaticTexts={staticTexts.time}
        >
          <JackpotBoxItem
            name={wonTier.name}
            scale={decideJackpotBoxScale(1, wrapperSize)}
            winMessage={staticTexts.winMessage}
          >
            <JackpotNumber
              currencyCode={currencyCode}
              value={wonTier.previousPrice || wonTier.curValue}
              jackpotScale={decideJackpotBoxScale(1, wrapperSize)}
              jackpotState={'won'}
              locale={locale}
              wrapperType={wrapperType}
            />
          </JackpotBoxItem>
          <JackpotBoxItem name={staticTexts.nextJackpot || ''} scale={'small'}>
            <JackpotNumberDynamic
              currencyCode={currencyCode}
              value={wonTier.curValue}
              jackpotScale={'small'}
              jackpotState={'normal'}
              locale={locale}
              wrapperType={wrapperType}
              timestamp={timestamp}
            />
          </JackpotBoxItem>
        </JackpotBox>
      </div>
    );
  }
  return (
    <div className={styles.container} data-testid="jackpots-holder">
      {selectedJackpots.map((tier, index) => (
        <JackpotBox
          key={tier.name}
          scale={decideJackpotBoxScale(index, wrapperSize)}
          timeStaticTexts={staticTexts.time}
          state={tier.state}
          releaseMessage={tier.releaseMessage}
          releaseTime={tier.releaseTime}
        >
          <JackpotBoxItem
            name={tier.name}
            scale={decideJackpotBoxScale(index, wrapperSize)}
            winMessage={tier.winMessage}
          >
            <JackpotNumberDynamic
              currencyCode={currencyCode}
              value={tier.winValue || tier.curValue}
              jackpotScale={decideJackpotBoxScale(index, wrapperSize)}
              jackpotState={tier.state}
              locale={locale}
              wrapperType={wrapperType}
              timestamp={timestamp}
            />
          </JackpotBoxItem>
        </JackpotBox>
      ))}
    </div>
  );
};

export default JackpotsContainer;
